import { Box, Typography } from '@mui/material';
import { useTheme } from '@mui/material/styles';
import { useProgressCalculation } from '../hooks/useProgressCalculation';

interface StepProgressIndicatorProps {
  showPercentage?: boolean;
  size?: 'small' | 'medium';
  variant?: 'compact' | 'detailed';
}

export const StepProgressIndicator = ({
  showPercentage = true,
  size = 'medium',
  variant = 'compact'
}: StepProgressIndicatorProps) => {
  const theme = useTheme();
  const { totalProgress, completedSteps, totalSteps } =
    useProgressCalculation();

  const getProgressColor = () =>
    totalProgress >= 100
      ? theme.palette.success.main
      : theme.palette.primary.main;
  const trackColor = theme.palette.divider;

  const getHeight = () => {
    return size === 'small' ? 4 : 6;
  };

  if (variant === 'compact') {
    return (
      <Box
        sx={{ display: 'flex', alignItems: 'center', gap: 2, width: '100%' }}
      >
        <Box
          sx={{
            flex: 1,
            height: getHeight(),
            backgroundColor: trackColor,
            borderRadius: getHeight() / 2,
            overflow: 'hidden'
          }}
        >
          <Box
            sx={{
              width: `${totalProgress}%`,
              height: '100%',
              backgroundColor: getProgressColor(),
              borderRadius: getHeight() / 2,
              transition: 'all 0.3s ease-in-out'
            }}
          />
        </Box>
        {showPercentage && (
          <Typography
            variant="caption"
            sx={{
              color: getProgressColor(),
              fontWeight: 'bold',
              minWidth: '35px',
              textAlign: 'right'
            }}
          >
            {completedSteps}/{totalSteps}
          </Typography>
        )}
      </Box>
    );
  }

  return (
    <Box sx={{ display: 'flex', alignItems: 'center', gap: 2 }}>
      <Box
        sx={{
          flex: 1,
          height: getHeight(),
          backgroundColor: trackColor,
          borderRadius: getHeight() / 2,
          overflow: 'hidden'
        }}
      >
        <Box
          sx={{
            width: `${totalProgress}%`,
            height: '100%',
            backgroundColor: getProgressColor(),
            borderRadius: getHeight() / 2,
            transition: 'all 0.3s ease-in-out'
          }}
        />
      </Box>
      {showPercentage && (
        <Typography
          variant="body2"
          sx={{
            color: getProgressColor(),
            fontWeight: 'bold',
            minWidth: '40px',
            textAlign: 'right'
          }}
        >
          {completedSteps}/{totalSteps}
        </Typography>
      )}
    </Box>
  );
};
